export default "__VITE_ASSET__LOc1SBXg__"